<template>
  <div class="animate-pulse rounded-md bg-neutral-300" />
</template>
